export default __webpack_public_path__ + "static/media/device.ad70be9f.png";